import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";

export const CommonReportTable: React.FC<any> = ({reportdata}: any) => {
  //console.log(reportdata);
  return (
    <>
      <div className="flex min-h-[calc(100vh-63px)] px-5 py-5">
        <NeoAGgrid table={reportdata} />
        {/* </div> */}
      </div>
    </>
  );
};
